
import { SellCategories } from "@/models/dossier-configs/sell-categories";
import { Product } from "@/models/base";
import { DossierConfigService } from "@/services/dossier-config-service";
import Vue from "vue";
import AppSellPrice from "./ProductInfoSellPrice.vue";

interface IVisibleCategories {
	categoryName: string;
	category: number;
}

export default Vue.extend({
	data() {
		return {
			visiblePrices: [] as IVisibleCategories[],
			toAddPricePerUnit: "0",
			selectedTab: 0
		};
	},
	props: {
		product: Object as () => Product
	},
	computed: {
		priceCategories(): SellCategories {
			return DossierConfigService.getSellCategories();
		},
		tabNames(): string[] {
			return this.visiblePrices.map(v => v.categoryName);
		},
		showAddPriceButton(): boolean {
			return this.visiblePrices.length < 10;
		},
		selectedPricateCategory(): number {
			return this.visiblePrices[this.selectedTab].category;
		}
	},
	watch: {
		product: {
			immediate: true,
			handler(product: Product) {
				this.computeVisibleCategories();
			}
		},
		priceCategories: {
			immediate: true,
			handler(categories: SellCategories) {
				this.computeVisibleCategories();
			}
		}
	},
	methods: {
		computeVisibleCategories() {
			this.visiblePrices = [];
			let cats = this.priceCategories.getCategories();
			for (let cat of cats) {
				if (cat.Active) {
					let catNumber = cats.indexOf(cat) + 1;
					this.visiblePrices.push({
						categoryName: this.priceCategories.getCategoryName(catNumber),
						category: catNumber
					});
				}
			}
		},
	},
	components: {
		AppSellPrice
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
